import React, { useContext } from 'react';
import classes from './MainBlock.module.css';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../App';
import Particle from '../Particle/Particle';

export default function MainBlock() {
  const { theme } = useContext(ThemeContext);

  return (
    <div
      className={
        classes.mainBlockContainer +
        ' flex justify-center items-center lg:justify-start'
      }
    >
      <div
        style={{ height: '100vh', overflow: 'hidden', position: 'relative' }}
      >
        <Particle />
      </div>

      <div
        id={classes[theme]}
        className={
          classes.infoMainBlock +
          ' text-center mx-auto p-0 lg:p-4vw-left sm:mx-0 lg:text-left  lg:justify-start'
        }
      >
        <h2 className="text-smBigSepTxt text-text md:text-mdBigSepTxt md:w-4/5 lg:w-full md:mx-auto lg:mx-0 lg:text-lgBigSepTxt">
          <strong>Fast</strong> results, <strong>reliable</strong> solutions
        </h2>
        <h5
          className={
            'text-smAddTxt md:text-mdAddTxt lg:text-lgAddTxt w-4/5 mx-auto lg:mx-0 hidden lg:block '
          }
        >
          Development experts for your business. Quality in every line of code,
          experience in every project.
        </h5>
        <Link to="/contactUs">
          <button
            className={
              classes.contactBtn +
              ' text-smSepBtnTxt md:text-mdSepBtnTxt lg:text-lgSepBtnTxt p-2vh10vw lg:p-2vh4vw'
            }
          >
            Contact us
          </button>
        </Link>
      </div>
    </div>
  );
}
